import AxiosInstance from "./api";

export const FixedAssetRevaluationService = {
  paginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/fixed-asset-revaluation-record/paginate", {
      params: query,
    });
  },
  init: async () => {
    return await AxiosInstance.get("/private/fixed-asset-revaluation-record/init");
  },
  getById: async (id) => {
    return await AxiosInstance.get("/private/fixed-asset-revaluation-record/" + id);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/fixed-asset-revaluation-record", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.put("/private/fixed-asset-revaluation-record/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/private/fixed-asset-revaluation-record/" + id);
  },
};
